import { LoadState } from "../../../constants/enums";

export interface ITestOneState {
  list: ITestOne[];
  loading: LoadState;
}

export interface ITestOne  {
  accn_invoice_information_id: number;
  invoice_number: string | null;
  invoice_date: string | null;
  invoice_due_date: string | null;
  payment_terms: string | null;
  accounting_information_id: number | null;
  gl_sales_account_name: string | null;
  gl_sales_account: string | null;
  gl_account_code: string | null;
  policy_status: string | null;
  address: string | null;
  unit_or_suite: string | null;
  city: string | null;
  province_or_state: string | null;
  postal_code: string | null;
  transaction_date: string | null;
  transaction_effective_date: string | null;
  effective_date: string | null;
  expiry_date: string | null;
  default_tax_region: string | null;
  agency_or_direct_bill: string | null;
  insurer_code: string | null;
  branch: string | null;
  branch_code: string | null;
  premium_financed: string | null;
  financed_by: string | null;
  policy_commission_code: string | null;
  sub_total_dollar: string | null;
  total_due_dollar: string | null;
  net_payable_insurer: string | null;
  invoice_notes: string | null;
  invoice_footer_information: string | null;
  type_of_policy: string | null;
  tax_one_total: string | null;
  tax_two_total: string | null;
  commission_total: string | null;
  is_mannual_invoice: number | null;
  financed_fee: string | null;
  amount_due: string | null;
  amount_paid: string | null;
  invoice_status: string | null;
  accn_invoice_payment_accounts_receivable_id: number | null;
  payment_id: number | null;
  payment_number: string | null;
  invoice_id: number | null;
  entry_type: string | null;
  gl_accounts: string | null;
  invoice_payment_gl_account_name: string | null;
  date: string | null;
  batch_id: number | null;
  receipt_id: number | null;
  payment_for: string | null;
  name: string | null;
  code: string | null;
  policy_number: string | null;
  policy_id: number | null;
  payment_type: string | null;
  payment_currency: string | null;
  payment_amount: string | null;
  service_fee: string | null;
  payment_method: string | null;
  bank: string | null;
  reference_info: string | null;
  invoice_details: string | null;
  total_paid: string | null;
  amount_excess: string | null;
  total_due: string | null;
  is_manual_invoice: number | null;
  file_upload: any[]; // or a more specific type if available
  status: string | null;
  created_by_id: number | null;
  create_ts: string | null;
  insert_ts: string | null;
}

export const initialTestOneState: ITestOneState =
  {
	list: [],
	loading: LoadState.NotLoaded,
  };
